import { Space, Table } from 'antd';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import {
	DeleteActionSvg,
	EditActionSvg
} from 'utils/svgs';
import { checkPermission } from 'utils/utils';
import SearchAndFilter from '../SearchAndFilter';
import styles from './index.module.scss';
import './index.scss';
import { CustomUserTableProps } from './type';


const CustomTable: FC<CustomUserTableProps> = (props) => {

	const { Column } = Table;
	const { dataSource, handleTableChange, isLoading, search, performSearchHandler, performFilterHandler, filterValue, openDrawerHandler, setDrawerInfoHandler, setEditSelectedWarningTag, showModal, isSearchCancel, setSearch, setIsSearchCancel } = props

	const userPermissions = useSelector(
		(state: any) => state?.userProfile
	);
	const isEditPermission = checkPermission(userPermissions?.data?.permissions, {
		permissionName: 'WarningTags',
		permission: ['edit'],
	});

	const isDeletePermission = checkPermission(userPermissions?.data?.permissions, {
		permissionName: 'WarningTags',
		permission: ['delete'],
	});


	const editDataHandler = (categoryObject: any) => {
		openDrawerHandler();
		setDrawerInfoHandler('Edit Warning Tag');
		setEditSelectedWarningTag(categoryObject);
	};

	// Delete warning tag data handler
	const deleteDataHandler = (categoryObject: any) => {
		setEditSelectedWarningTag(categoryObject);
		showModal();
	};

	return (
		<>
			<div className={`${styles['body']} user-table-pagination `} >
				<SearchAndFilter
					performSearchHandler={performSearchHandler}
					searchValue={search}
					performFilterHandler={performFilterHandler}
					filterValue={filterValue}
					title={'Warning Tag List'}
					openDrawerHandler={openDrawerHandler}
					isSearchCancel={isSearchCancel}
					setSearch={setSearch}
					setIsSearchCancel={setIsSearchCancel}
				/>

				<Table
					rowKey={(record: any) => record?.id}
					dataSource={dataSource}
					pagination={false}
					loading={isLoading}
					onChange={handleTableChange}
					scroll={{ y: 'calc(100vh - 300px)' }}
				>
					<Column
						title={<p style={{ padding: '0 0px' }}> Warning Tag</p>}
						dataIndex="tagName"
						key="tagName"
						className="user-column bg-white"
						width={'15%'}
					/>

					{(isEditPermission || isDeletePermission) && (
						<Column
							title="Action"
							dataIndex="action"
							key="action"
							className="bg-white"
							width={'15%'}
							render={(value, data: any) => {
								return (
									<Space size={20}>
										{isEditPermission ? (
											<div
												className="cursor-pointer flex align-center justify-center rounded-action-btn"
												onClick={() =>
													editDataHandler(data)
												}
											>
												<EditActionSvg />
											</div>
										) : (
											<div className=" cursor-not-allowed flex align-center justify-center rounded-action-btn">

												<EditActionSvg />
											</div>
										)}

										{isDeletePermission
											? (
												<div
													className="cursor-pointer flex align-center justify-center rounded-action-btn "
													onClick={() =>
														deleteDataHandler(data)
													}
												>
													<DeleteActionSvg />
												</div>
											) : (
												<div className=" cursor-not-allowed flex align-center justify-center rounded-action-btn ">
													<DeleteActionSvg />
												</div>
											)}
									</Space>
								);
							}}
						/>
					)}
				</Table>
			</div>
		</>
	);
};

export default CustomTable;
